/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Empty"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Empty.Text"
  data-view-path={viewPath}
 className="views-text"
>
There are no results
</span>
{children}
</React.Fragment>)
}